import { fetchRequest } from "../requester/fetchRequest";

import service_settings from "./../service.discovery.json";

const baseURL = service_settings.trade_url;

/* Login */
export function authentication(data, otp = null) {
    let headers = {
        method: 'POST',
        data: {
            'username': data?.username,
            'password': data?.password,
            'otp': otp
        }
    }

    return fetchRequest(baseURL + 'auth/login', headers);
}

/* Logout */
export function userLogout() {
    let headers = {
        method: 'POST',
        data: {}
    }

    return fetchRequest(baseURL + 'auth/logout', headers);
}

/* Get user */
export function currentUser() {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + 'users/me', headers);
}

/* Get user organizations */
export function userOrganization() {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + 'users/me/organizations', headers);
}

/* Get user portfolios */
export function fetchPortfolios(organizationId) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/intraday/portfolios/`, headers);
}

/* Get portfolio trading chart */
export function getTradingChart(organizationId, portfolioId, date) {
    let headers = {
        method: 'GET'
    }
    let url = date ?
        baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_chart?date=${date}` :
        baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_chart`

    return fetchRequest(url, headers);
}

/* Get portfolio trading report */
export function getTradingReport(organizationId, portfolioId, startDate = null, endDate = null) {
    let headers = {
        method: 'GET'
    }

    const url = endDate ?
        baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report?start_date=${startDate}&end_date=${endDate}` :
        startDate ?
            baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report?start_date=${startDate}` :
            baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report`

    return fetchRequest(url, headers);
}


/* Get signals data */
export function getSignals(organizationId, portfolioId) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/signals`, headers);
}

/* Get prices */
export function getPrices(delivery_period) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `prices/day_ahead?delivery_period=${delivery_period}`, headers);
}

/* Get alerts */
export function getAlerts() {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `logs/recent`, headers);
}

/* Update signals */
export function updateSignals(organizationId, portfolioId, data) {
    let headers = {
        method: 'PATCH',
        data: JSON.stringify({ items: data })
    };

    return fetchRequest(baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/signals`, headers);
}

/* Get status */
export function getStatus(organizationId, portfolioId) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/status`, headers);
}

/* Validate signals */
export function validateSignals(organizationId, portfolioId,data) {
    let headers = {
        method: 'POST',
        data: JSON.stringify({ items: data })
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/signals/validate`, headers);
}

/* Change portfolio trading status */
export function updatePortfolioTradingStatus(organizationId, portfolioId, data) {
    let headers = {
        method: 'PATCH',
        data: JSON.stringify(data)
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}`, headers);
}

/* Get organization users */
export function fetchOrganizationUsers(organizationId) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/users`, headers);
}

/* Get portfolio trading report - excel */
export function getTradingReportExcel(organizationId, portfolioId, startDate = null, endDate = null) {
    let headers = {
        method: 'GET'
    }

    const url = endDate ?
        baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report/excel?start_date=${startDate}&end_date=${endDate}` :
        startDate ?
            baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report/excel?start_date=${startDate}` :
            baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report/excel`

    return fetchRequest(url, headers, { responseType: 'blob' });
}

/* Get portfolio trading report - csv */
export function getTradingReportCsv(organizationId, portfolioId, startDate = null, endDate = null) {
    let headers = {
        method: 'GET'
    }

    const url = endDate ?
        baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report/csv?start_date=${startDate}&end_date=${endDate}` :
        startDate ?
            baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report/csv?start_date=${startDate}` :
            baseURL + `organizations/${organizationId}/intraday/portfolios/${portfolioId}/trading_report/csv`

    return fetchRequest(url, headers, { responseType: 'text' });
}

/* Get organization documents */
export function fetchOrganizationDocuments(organizationId) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/documents`, headers);
}

/* Upload document */
export function uploadDocument(organizationId, data) {
    let headers = {
        method: 'POST',
        data: data
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/documents`, headers);
}

/* Get organization document download link */
export function fetchDocumentForDownload(organizationId,documentId) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/documents/${documentId}/download`, headers, { responseType: 'arraybuffer' });
}

/* Delete document */
export function deleteDocument(organizationId,documentId) {
    let headers = {
        method: 'DELETE'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/documents/${documentId}`, headers);
}

/* Change password */
export function changePassword(data) {
    let headers = {
        method: 'POST',
        data: {
            'old_password': data?.oldPassword,
            'new_password': data?.password
        }
    }

    return fetchRequest(baseURL + `auth/change_password`, headers);
}

/* Get user reports */
export function fetchUserReports(organizationId) {
    let headers = {
        method: 'GET'
    }

    return fetchRequest(baseURL + `organizations/${organizationId}/user_reports`, headers);
}

/* Get user report */
export function getUserReport(organizationId, reportId, startDate = null, endDate = null) {
    let headers = {
        method: 'GET'
    }

    const url = endDate ?
        baseURL + `organizations/${organizationId}/user_reports/${reportId}?start_date=${startDate}&end_date=${endDate}` :
        startDate ?
            baseURL + `organizations/${organizationId}/user_reports/${reportId}?start_date=${startDate}` :
            baseURL + `organizations/${organizationId}/user_reports/${reportId}`

    return fetchRequest(url, headers);
}

/* Get user reports excel */
export function getUserReportsExcel(organizationId, startDate = null, endDate = null) {
    let headers = {
        method: 'GET'
    }

    const url = endDate ?
        baseURL + `organizations/${organizationId}/user_reports/excel?start_date=${startDate}&end_date=${endDate}` :
        startDate ?
            baseURL + `organizations/${organizationId}/user_reports/excel?start_date=${startDate}` :
            baseURL + `organizations/${organizationId}/user_reports/excel`

    return fetchRequest(url, headers, { responseType: 'blob' });
}

/* Get user report excel */
export function getUserReportExcel(organizationId, reportId, startDate = null, endDate = null) {
    let headers = {
        method: 'GET'
    }

    const url = endDate ?
        baseURL + `organizations/${organizationId}/user_reports/${reportId}/excel?start_date=${startDate}&end_date=${endDate}` :
        startDate ?
            baseURL + `organizations/${organizationId}/user_reports/${reportId}/excel?start_date=${startDate}` :
            baseURL + `organizations/${organizationId}/user_reports/${reportId}/excel`

    return fetchRequest(url, headers, { responseType: 'blob' });
}